import React from "react";
import "./footer.css";

const Footer = () => (
  <div className="ai__footer section__padding">
    <div className="ai__footer-links">
      <div className="ai__footer-links_logo">
        <h1>NexusAI</h1>
        <p>
        1435 Vine Street, Cincinnati, OH 45202<br /> All Rights Reserved
        </p>
      </div>
      <div className="ai__footer-links_div">
        <h4>Links</h4>
        <p>Home</p>
        <p>About</p>
        <p>Features</p>
      </div>
      <div className="ai__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions </p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="ai__footer-links_div">
        <h4>Contact</h4>
        <p>1435 Vine Street, Cincinnati, OH 45202</p>
        <p>774-482-4383</p>
        <p>nexusai@usa.com</p>
      </div>
    </div>

    <div className="ai__footer-copyright">
      <p>@2024 NexusAI All rights reserved.</p>
    </div>
  </div>
);

export default Footer;
